import { DefaultTagContent } from './default-tag-content';

export { DefaultTagContent };
